import PropTypes from 'prop-types'
import React from 'react';
import styles from './TeamMember.module.scss'
import HTMLContent from "../../../partials/HTMLContent";

/**
 *
 * @param member
 * @returns {JSX.Element}
 * @constructor
 */
function TeamMember({ member }) {
    if (!member) return null;
    return <div className={styles.TeamMember}>
        <div className={styles.Avatar}>
            <div className={styles.Image}>
                <img src={member.img} />
            </div>
            <div className={styles.Name}>
                {member.name}
            </div>
            <div className={styles.Role}>
                {member.role}
            </div>
        </div>
        <div className={styles.Dialog}>
            <HTMLContent html={member.dialogue} />
        </div>
    </div>
}

export default TeamMember;

TeamMember.propTypes = {
  member: PropTypes.any
}
